import { StaffManagerFormValues } from "../components/forms/StaffManagerForm/StaffManagerForm.types";
import { updateStaffManagerPayload } from "./../apis/useUpdateStaffManager/updateStaffManager.types";

export const convertManagerFormDataToUpdateBody = (
  beforeUpdateManagerData: StaffManagerFormValues,
  formData: StaffManagerFormValues
): updateStaffManagerPayload => ({
  id: formData.id as string,
  imageId: formData.image?.id ?? null,
  firstName: formData.firstName,
  lastName: formData.lastName,
  password: formData.password || undefined,
  repeatPassword: formData.repeatPassword || undefined,
  email:
    beforeUpdateManagerData.email !== formData.email
      ? formData.email
      : undefined,
  privileges: formData?.privileges ?? [],
  permissions: formData?.permissions ?? []
});
